// styles
import './styles/graphic.scss';

export default function (props, container, isMobile) {
  const {
    color,
    data,
    fmtYearAbbrev,
    fmtYearFull,
    fmtMonth,
    height,
    initialWidth,
    initialHeight,
    margins,
    path,
    width,
    x,
    xAxis,
    y,
    yAxis,
    parser,
  } = props;

  const xTicks = isMobile ? 10 : 10;
  const yTicks = isMobile ? 5 : 5;

  const xGrid = xAxis(x)
    .ticks(xTicks)
    .tickFormat(d => (isMobile
      ? `\u2019${fmtYearAbbrev(d)}`
      : fmtYearFull(d)));

  // legend
  container.insert('ul', ':first-child')
    .attr('class', 'key')
    .selectAll('li')
    .data(data)
    .enter()
    .append('li')
    .attr('class', 'key-item')
    .html(d => `<span class='key-block' style='background-color:${color(d.id)};'></span> ${d.id}`);

  // svg
  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const g = svg.append('g')
    .attr('transform', `translate(${[margins.left, margins.top]})`);

  // x axis
  g.append('g')
    .attr('class', 'grid x')
    .attr('transform', `translate(${[0, height]})`)
    .call(xGrid);

 	// y axis
  const yGrid = g.append('g')
    .attr('class', 'grid y')
    .call(yAxis(y).ticks(yTicks));

  // add tick prefix or suffix here
  // `${d}M`
  // `$${d}`
  yGrid.selectAll('text')
    .text(d => (d !== 0 ? `${d}%` : d));

  yGrid.selectAll('line').attr('x2', width);

  // lines
  const lines = g.append('g')
    .attr('class', 'lines')
    .selectAll('g')
    .data(data)
    .enter()
    .append('g')
    .attr('class', 'line');

  lines.append('path')
    .attr('stroke', d => color(d.id))
    .attr('d', d => path(d.values));

  const dotKey = ['dot'];
  const dottedLine = [
    {
      date: '2008-10-01',
      dot: 3.3,
    },
    {
      date: '2021-04-01',
      dot: 3.3,
    },
  ];

  const dotdata = dotKey.map(id => ({ id, values: dottedLine.map(d => ({ date: parser(d.date), value: +d[id] })) }));

  const dottedLines = g.append('g')
    .attr('class', 'lines-dotted')
    .selectAll('g')
    .data(dotdata)
    .enter()
    .append('g')
    .attr('class', 'line');

  dottedLines.append('path')
    .attr('stroke', d => 'gray')
    .attr('stroke-dasharray', '3,3')
    .attr('d', d => path(d.values));

  // labels
  const label = lines.append('g')
    .attr('class', 'data-label');

  label.append('text')
    .attr('transform', (d) => {
      const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
      const x0 = x(d0.date) + 5;
      const y0 = y(d0.value) + 3;
      return `translate(${[x0, y0]})`;
    })
    .text((d) => {
      const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
      const { value } = d0;
      return `${value.toFixed(1)}%`;
    });
}
